import WebLLCRESTApi from "../api/api";
import UUID from "../util/uuid";
import $ from 'jquery';

export default {
  name: "AddClientImages",
  
  created() {
    this.api = new WebLLCRESTApi("Client-Images", this.$router);
  },
  
  props: {
      clientId: {
          type: String,
      },
  },
  
  data() {
    return {
      txtDescription: "",
      cmbMain: "yes"
    }
  },
  
  methods: {
    async onAddSingle() {
      document.getElementById("fleClientImage").multiple = false;
      document.getElementById("fleClientImage").click();
    },
    
    async onAddMultiple() {
      document.getElementById("fleClientImage").multiple = true;
      document.getElementById("fleClientImage").click();
    },
    
    async onFileUpload(evt) {
      const files = evt.target.files;
      
      for(var index=0; index<files.length; index++) {
        const file = files[index];
        
        const formData = new FormData();
        formData.append("description", this.txtDescription);
        formData.append("main", (this.cmbMain == "yes"));
        formData.append("img", file);
        formData.append("clientId", this.clientId);
        
        const res = await this.api.addData(formData);
        const json = await res.json();
      }
      
      this.$emit('added', true);
      $('#modal-add-images-data').modal('toggle');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AddClientImages.js